"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = require("babel-runtime/core-js/json/stringify");

var _stringify2 = _interopRequireDefault(_stringify);

var _assign = require("babel-runtime/core-js/object/assign");

var _assign2 = _interopRequireDefault(_assign);

var _env = require("../../utils/env");

var _env2 = _interopRequireDefault(_env);

var _common = require("../../utils/common");

var _common2 = _interopRequireDefault(_common);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var VouchesService = function VouchesService(HttpService) {
  "ngInject";

  var getDataSource = function getDataSource(successCb) {
    var dataSource = new kendo.data.DataSource({
      transport: {
        read: {
          url: _env2.default.getApiUrl("vouches/search"),
          contentType: "application/json",
          type: "POST",
          beforeSend: _onBeforeSend
        },
        update: {
          url: _getResourceLocation,
          contentType: "application/json",
          type: "PATCH",
          beforeSend: _onBeforeSend
        },
        create: {
          url: _env2.default.getApiUrl("vouches/create"),
          contentType: "application/json",
          type: "POST",
          beforeSend: _onBeforeSend,
          complete: function complete(e) {
            $("#vouches-grid").data("kendoGrid").dataSource.read();
          }
        },
        parameterMap: _parameterMap
      },
      change: successCb,
      schema: {
        data: "data",
        total: "total",
        model: {
          id: "id",
          fields: {
            "creationDate": { type: "date", editable: false, validation: { required: true } },
            // "code": { nullable: false, validation: { required: true } },
            // "startDate": { type: "date", nullable: false, validation: { required: true } },
            // "expireDate": { type: "date", nullable: false, validation: { required: true } },
            "fullName": { nullable: false, validation: { required: true } },
            "whatWouldYouLikeToSay": { nullable: false, validation: { required: true } },
            "notes": { nullable: false, validation: { required: false } },
            "status": { defaultValue: 0 },
            "referenceType": { defaultValue: 0 },
            "id": {},
            "jugglerId": {},
            "email": { defaultValue: '' },
            "phoneNumber": { defaultValue: '' }
          }
        }
      },
      serverFiltering: true,
      serverPaging: true,
      serverSorting: true,
      pageSize: 50
    });

    return dataSource;
  };

  return { getDataSource: getDataSource };
};

function _getResourceLocation(options) {
  return _env2.default.getApiUrl("vouches/" + options.id);
}

function _onBeforeSend(req) {
  var token = "Bearer " + window.localStorage.getItem("bigfootAccessToken");

  req.setRequestHeader("Authorization", token);
}

function _parameterMap(data, type) {
  if (type == "read") {
    var filters = [];

    if (data.filter) filters = data.filter.filters;

    var query = (0, _assign2.default)({}, { filters: filters }, data);
    delete query.filter;

    console.log("Query::", query);

    return (0, _stringify2.default)(query);
  }

  if (type == "create") {

    // Dates used in the DataSource are JavaScript Date objects.
    // Therefore convert the date to utc before sending to remove dateoffset.

    delete data.id;
    // data.expireDate = common.converToUtcDate(data.expireDate);
    // data.startDate = common.converToUtcDate(data.startDate);

    console.log("Data::", data);

    return (0, _stringify2.default)(data);
  }

  if (type == "update") {

    // Dates used in the DataSource are JavaScript Date objects.
    // Therefore convert the date to utc before sending to remove dateoffset.

    // data.expireDate = common.converToUtcDate(data.expireDate);
    // data.startDate = common.converToUtcDate(data.startDate);

    console.log("Data::", data);

    return (0, _stringify2.default)(data);
  }
}

exports.default = VouchesService;


/** WEBPACK FOOTER **
 ** ./client/app/common/services/vouches.service.js
 **/